const colors = {
    p1: '#150016',
    p2: '#29104A',
    p3: '#522C5D',
    p4: '#845162',
    p5: '#E3B6B1',
    p6: '#FFE3D8',
    darkPurple: '#150016',
    purple: '#9B7EBD',
    lightPurple: '#D4BEE4',
    white: '#EEEEEE',
    black: '#000000',

    // Dark Mode Colour Pallete
    d1: '#0a042c', //main bg color
    d2: '#1e1454', //second bg color
    d3: '#2d1e77', //border color
    d4: '#7a67de',
    d5: '#4A148C', //date picker 
    dbackground: '#0a042c',
    dfont: '#ffffff',
    // Light Mode Colour Pallete
    l1: '#ffffff',
    l2: '#f8f5fe', //second main
    l3: '#d9d6e5',
    l4: '#100c3f',//purple
    l5: '#100c3f',
    l6: '#c3b5dd',
    l7: '#fcfaff',
    l8: '#0a042c',
    lbackground: '#dfdf2f2f5fdf',
    lfont: '#333333',
    //  Font and toggle Colour Pallete
    f1: '#717171', //gray
    f2: '#ffffff',
    f3: '#000000',
    f4: '#bfbfbf', //darkmodegray
    f5: '#434343', //lightmodegray
    //  Hover Colour Pallete
    h1: '#f2f2f2',
    //  icon Colour Pallete
    i1: '#843AE5',
    //  graph Colour Pallete
    g1: '#ff3621',//red
    g2: '#ffaf56',//orange
    g3: '#149fff',//blue
    g4: '#108a00',//green
    g5: '#0c0c0c',//gray
    g6: '#E0E0E0',
    g7: '#dba92b',//darkorange
    g8: '#f86d5d',//darkred
    g9: '#0062a6',//darkblue
    g10: '#a7d144',//darkgreen
    g11: '#9f37d3',//darkgray
    g12: '#af9b65',//lightgray
    g13: '#5bb5ff',


    //bill components
    b1: 'rgba(255, 255, 255, 0)',
    b2: 'rgba(255, 255, 255,0.4)',
    b3: 'rgba(243, 252, 255, 0.37)',
    bfD: '#c2c2c2',//bill font darkmode
    bfL: '#6d6d6d',//bill font lightmode
    fgD: '#3ffa3a',//green font darkmode
    fgL: '#5aba57',//green font lightmode

    //  table Colour Pallete
    t1: '#0078d4',//table border color(blue)
    t2: '#bad1e28c',//table head color(blue)
    t3: '#f1f1f1',//table head color(gray)
    t4: '#bdbdbd',//table border color(gray)
    t5: '#96e7899a',//table head color(green)
    t6: '#26bc0e',//table border color(green)
    t7: '#fe916e',//table head color(red)
    t8: '#cc3403',//table border color(red)
    t9: '#fdc062',//table head color(yellow)
    t10: '#fe9a00',//table border color(yellow)
    t11: '#c8c8d848',//table even row color(light gray)
    t12: '#eb86864d',//table odd row color(dark gray)


    //big screen
    bs1: "linear-gradient(to right, rgba(0, 54, 104, 0.8), rgba(0, 109, 143, 0.8))",//box background
    bs2: ' rgba(0, 39, 65, 0.9)',//box border
    bs3: 'rgba(0, 136, 177, 0.81)',//box background 2
    bs4: "linear-gradient(to bottom, rgba(0, 24, 46, 1), rgba(0, 104, 136, 1))",//box background 3
    bs5: 'rgba(0, 150, 187, 0.8)',//6boxes-LEFT&RIGHT
    bs6: 'rgba(0, 114, 190, 0.8)',//3boxes-BOTTOM
    bs7: 'rgb(0, 28, 54)',
    bsf1: 'rgb(188, 253, 255)',//font color
    bsg1: 'rgba(96, 255, 207, 0.88)',//graph color
    bsg2: 'rgba(103, 174, 255, 0.85)',//graph color
    bsg3: 'rgba(236, 80, 40, 0.8)',//graph color



};

export default colors;